<expandable expandableTitle="Delivery & Returns"
            expandableId="productDetails.delivery">
    <div *iCms="'copy' of content; content: 'html'"
         class="text col-1"></div>
</expandable>
